module.exports = __webpack_public_path__ + "static/img/store_upgrade.56d8857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store_upgrade.png
// module id = ZLmx
// module chunks = 134